<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> updated a trigger.-->
        <span v-html="$t('notification.triggerUpdated', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TriggerUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
